import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const addons = async (id, region = "") => {
    const queryParam = region ? `?region=${region}` : "";
    const response = await axios.get(
        routes.addons(id) + queryParam,
        AXIOS_DEFAULT_CONFIG
    );
    return response;
}
export default addons;
